import React, { Component } from "react";
import { registerToast } from "./toastService";
import "../toast.css";

let toastIdCounter = 0;
const MAX_TOASTS = 4;

class ToastContainer extends Component {
  state = {
    toasts: []
  };

  // store all timers to prevent leaks
  timers = {};

  componentDidMount() {
    registerToast(this.addToast);
  }

  componentWillUnmount() {
    // clear all pending timeouts
    Object.values(this.timers).forEach(clearTimeout);
  }

  getIcon = (type) => {
    switch (type) {
      case "success":
        return "✔";
      case "error":
        return "✖";
      case "warning":
        return "⚠";
      default:
        return "ℹ";
    }
  };

  addToast = ({
    message,
    type = "info",
    duration = 3000,
    position = "bottom-right"
  }) => {
    const newToast = {
      id: toastIdCounter++,
      message,
      type,
      position,
      duration
    };

    this.setState((prev) => {
      const updated = [...prev.toasts, newToast];

      // enforce max limit
      if (updated.length > MAX_TOASTS) {
        const removed = updated.shift();
        clearTimeout(this.timers[removed.id]);
        delete this.timers[removed.id];
      }

      return { toasts: updated };
    });

    // auto remove toast after duration
    this.timers[newToast.id] = setTimeout(() => {
      this.removeToast(newToast.id);
    }, duration);
  };

  removeToast = (toastId) => {
    clearTimeout(this.timers[toastId]);
    delete this.timers[toastId];

    this.setState((prev) => ({
      toasts: prev.toasts.filter((t) => t.id !== toastId)
    }));
  };

  renderToasts(position) {
    return this.state.toasts
      .filter((t) => t.position === position)
      .map((t) => (
        <div
          key={t.id}
          className={`toast ${t.type}`}
          style={{ "--duration": `${t.duration}ms` }}
        >
          <span className="tw-mr-2">
            {this.getIcon(t.type)} {t.message}
          </span>
          <button onClick={() => this.removeToast(t.id)}>✕</button>
        </div>
      ));
  }

  render() {
    return (
      <>
        <div className="toast-container top-right">
          {this.renderToasts("top-right")}
        </div>

        <div className="toast-container bottom-center">
          {this.renderToasts("bottom-center")}
        </div>

        <div className="toast-container bottom-left">
          {this.renderToasts("bottom-left")}
        </div>
        <div className="toast-container bottom-right">
          {this.renderToasts("bottom-right")}
        </div>
      </>
    );
  }
}

export default ToastContainer;